import AreaDownloadTemplate from './AreaDownloadTemplate/AreaDownloadTemplate'
import AudioDescrizioneTemplate from './AudioDescrizioneTemplate/AudioDescrizioneTemplate'
import AziendaDetailTemplate from './AziendaDetailTemplate/AziendaDetailTemplate'
import AziendaHubTemplate from './AziendaHubTemplate/AziendaHubTemplate'
import BrandTemplate from './BrandTemplate/BrandTemplate'
import CertificazioniHubTemplate from './CertificazioniHubTemplate/CertificazioniHubTemplate'
import CollezioneDetailTemplate from './CollezioneDetailTemplate/CollezioneDetailTemplate'
import ContattaRivenditoreTemplate from './ContattaRivenditoreTemplate/ContattaRivenditoreTemplate'
import ContattaRivenditoreThankYouTemplate from './ContattaRivenditoreThankYouTemplate/ContattaRivenditoreThankYouTemplate'
import ContattiTemplate from './ContattiTemplate/ContattiTemplate'
import HomeTemplate from './HomeTemplate/HomeTemplate'
import LayoutEmpty from './LayoutEmpty/LayoutEmpty'
import ListingTemplate from './ListingTemplate/ListingTemplate'
import MagazineDetailTemplate from './MagazineDetailTemplate/MagazineDetailTemplate'
import MagazineHubTemplate from './MagazineHubTemplate/MagazineHubTemplate'
import NewsletterTemplate from './NewsletterTemplate/NewsletterTemplate'
import PagebuilderTemplate from './PagebuilderTemplate/PagebuilderTemplate'
import ProgettiDetailTemplate from './ProgettiDetailTemplate/ProgettiDetailTemplate'
import ProgettiHubTemplate from './ProgettiHubTemplate/ProgettiHubTemplate'
import RivenditoriTemplate from './RivenditoriTemplate/RivenditoriTemplate'
import SearchResultTemplate from './SearchResultTemplate/SearchResultTemplate'
import SoluzioniDetailTemplate from './SoluzioniDetailTemplate/SoluzioniDetailTemplate'
import SoluzioniTemplate from './SoluzioniTemplate/SoluzioniTemplate'
import SostenibilitaDetailTemplate from './SostenibilitaDetailTemplate/SostenibilitaDetailTemplate'
import SostenibilitaHubTemplate from './SostenibilitaHubTemplate/SostenibilitaHubTemplate'
import TaxesTemplate from './TaxesTemplate/TaxesTemplate'
import TecnologieDetailTemplate from './TecnologieDetailTemplate/TecnologieDetailTemplate'
import TecnologieHubTemplate from './TecnologieHubTemplate/TecnologieHubTemplate'
import Template404 from './Template404/Template404'
import TonalitaDetailTemplate from './TonalitaDetailTemplate/TonalitaDetailTemplate'

export {
  AreaDownloadTemplate,
  AudioDescrizioneTemplate,
  AziendaDetailTemplate,
  AziendaHubTemplate,
  BrandTemplate,
  CertificazioniHubTemplate,
  CollezioneDetailTemplate,
  ContattaRivenditoreTemplate,
  ContattaRivenditoreThankYouTemplate,
  ContattiTemplate,
  HomeTemplate,
  LayoutEmpty,
  ListingTemplate,
  MagazineDetailTemplate,
  MagazineHubTemplate,
  NewsletterTemplate,
  PagebuilderTemplate,
  ProgettiDetailTemplate,
  ProgettiHubTemplate,
  RivenditoriTemplate,
  SearchResultTemplate,
  SoluzioniDetailTemplate,
  SoluzioniTemplate,
  SostenibilitaDetailTemplate,
  SostenibilitaHubTemplate,
  TaxesTemplate,
  TecnologieDetailTemplate,
  TecnologieHubTemplate,
  Template404,
  TonalitaDetailTemplate,
}
